export default __webpack_public_path__ + "static/media/logo.7fbe3a5e.jpg";